/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core';
import SkeletonLoader from '@ion/dls/src/components/loading/SkeletonLoader';
import {DLSTheme} from '@ion/dls/src/types/types';

export const useStyles = makeStyles((theme: DLSTheme) => ({
  conflictsLoader : {
    padding : '48px 0px'
  }
}));

/**
 * @JobConflictsLoader
 * Defines the loader component for the JobConflictResolutionChooser component.
 * 
 * ```typescript
 * import {JobConflictsLoader} from ./JobConflictsLoader
 * 
 * <ConditionalRender condition={isLoading}>
 *   <JobConflictsLoader />
 * </ConditionalRender>
 * 
 * ```
 * 
 * @returns a loader component to display an intermediate state for the user.
 */
const JobConflictsLoader = () => {
  const classes = useStyles();
  return (
    <div className={classes.conflictsLoader}>
      <SkeletonLoader height={32} styles={{marginBottom: 24, width: '60%'}}/>
      <SkeletonLoader height={2} styles={{marginBottom: 24}}/>
      <SkeletonLoader height={24} styles={{marginBottom: 32, width: '40%'}}/>
      <SkeletonLoader height={450} styles={{marginBottom: 4}}/>
    </div>
  );
};

export default memo(JobConflictsLoader);
